import { useCurrentUser } from '../../../../../../hooks/useCurrentUser/useCurrentUser';
import { UserRoles } from '../../../../../../types/models/user/user.types';
import Modal from '../../../../../commons/Modal/Modal';
import Button from '../../../../../designSystem/Button/Button';
import { ButtonColor } from '../../../../../designSystem/Button/Button.types';
import { ProfilePasswordModalProps } from './ProfilePasswordModal.types';

export default (props: ProfilePasswordModalProps) => {
  const currentUser = useCurrentUser();

  return (
    <Modal {...props}>
      <h2>Mise à jour du compte</h2>
      <p>Votre mot de passe a bien été mises à jour.</p>
      <Button
        onClick={() => props.setOpen(false)}
        style={{ marginTop: 'var(--spacing-sToM)' }}
        color={
          currentUser?.role === UserRoles.Entreprise ? ButtonColor.Secondary : ButtonColor.Primary
        }>
        Fermer
      </Button>
    </Modal>
  );
};
